export default __webpack_public_path__ + "static/media/A B Shetty.c763a271.png";